/** Stable list-row key (one row per application course for package apps). */
export function getCommissionRowKey(application = {}) {
  if (application?.row_key) {
    return String(application.row_key);
  }

  const appId = application?.application_id ?? application?.applicationId ?? "";
  const appCourseId =
    application?.application_course_id ??
    application?.applicationcourseid ??
    application?.eduappcourse_id ??
    null;

  if (appCourseId != null && String(appCourseId).trim() !== "") {
    return `${appId}-${appCourseId}`;
  }

  return String(appId ?? "");
}

export function getCommissionCourseLabel(application = {}) {
  const courseName =
    application?.coursename ||
    application?.course_name ||
    application?.course?.name ||
    "";

  if (courseName) return courseName;

  return application?.packagename || "-";
}
